import LoginForm from '@/components/LoginForm';
import RegisterForm from '@/components/RegisterForm';
import Guest from '@/Layouts/GuestLayout';
import { cn, useQueryParams } from '@/lib/utils';
import { Head, usePage } from '@inertiajs/react';
import { useState } from 'react';

export default function Welcome() {
  const { auth } = usePage().props;
  const { referralCode } = useQueryParams<{ referralCode?: string }>();
  const [mode, setMode] = useState<'login' | 'register'>(
    referralCode ? 'register' : 'login',
  );

  return (
    <Guest>
      <Head title="Welcome" />

      <div
        className={cn(
          'flex min-h-[calc(100vh-3rem)] flex-col items-center gap-10 bg-gradient-to-t from-yellow-600/70 to-yellow-50 px-5 md:flex-row md:justify-between',
          auth.user && 'justify-center',
        )}
      >
        <div className="flex flex-col items-center justify-center pt-10 md:p-0">
          <h1 className="text-center text-4xl font-bold md:text-6xl">
            <p>
              <span className="text-primary drop-shadow">GTC</span> - Gold Time
              Community
            </p>
            <p className="text-2xl md:mt-3 md:text-4xl">
              Cộng đồng thời gian vàng
            </p>
          </h1>
          <p className="text-md mt-3">
            Thời gian vàng, thành công trong tầm tay
          </p>
        </div>

        {!auth.user &&
          (mode === 'login' ? (
            <LoginForm onClickSignUp={() => setMode('register')} />
          ) : (
            <RegisterForm
              onClickLogIn={() => setMode('login')}
              referralCode={referralCode}
            />
          ))}
      </div>
    </Guest>
  );
}
